import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  ShieldCheck,
  Zap,
  Users,
  PhoneCall,
  Wallet,
  TrendingUp,
  ArrowRight,
  Landmark,
  BadgeCheck,
  LockKeyhole,
  BarChart3,
  Headphones,
  CheckCircle2,
  Smartphone,
  Building2,
  PiggyBank,
  Clock3,
  FileCheck2,
  Banknote,
  UserCheck,
  Store,
  BriefcaseBusiness,
  Calculator,
  Sparkles,
  Star,
  CircleDollarSign,
  ChevronRight,
  Fingerprint,
  ReceiptText,
  ShieldAlert,
  LineChart,
  MessageCircleQuestion,
} from "lucide-react";

import "../assets/css/home.css";

import carousel1 from "../assets/img/carousel-1.png";
import carousel2 from "../assets/img/carousel-2.png";
import carousel3 from "../assets/img/carousel-3.png";
import aboutImg from "../assets/img/about.png";


import flyer1 from "../assets/img/car-for-cash.png";
import flyer2 from "../assets/img/property-loan.png";
import flyer3 from "../assets/img/civil-defence-loan.png";
import flyer4 from "../assets/img/partner-with-us.png";

console.log("flyer1 =", flyer1);
console.log("flyer2 =", flyer2);
console.log("flyer3 =", flyer3);
console.log("flyer4 =", flyer4);

import loanImg from "../assets/img/loan-card_1.png";
import investmentImg from "../assets/img/investment-card_1.png";
import advisoryImg from "../assets/img/advisory-card_1.png";

import businessLoanImg from "../assets/img/business-loan.png";
import financialPlanningImg from "../assets/img/financial-planning.png";
import cashInvestmentImg from "../assets/img/cash-investment.png";
import consultancyImg from "../assets/img/consultancy.png";
import growthImg from "../assets/img/growth-success.png";

const fadeUp = {
  hidden: { opacity: 0, y: 36 },
  visible: { opacity: 1, y: 0 },
};

const heroSlides = [carousel1, carousel2, carousel3];

const promoOffers = [
  {
    title: "Car For Cash",
    image: flyer1,
  },
  {
    title: "Property Loan",
    image: flyer2,
  },
  {
    title: "Civil Defence Loan",
    image: flyer3,
  },
  {
    title: "Partner With Us",
    image: flyer4,
  },
];

const services = [
  {
    title: "Instant Digital Loans",
    text: "Fast access to business and personal loans with a smooth digital process.",
    icon: Wallet,
    action: "Apply Now",
    image: loanImg,
  },
  {
    title: "Secure Lenders",
    text: "Grow your funds with trusted investment support and transparent guidance.",
    icon: PiggyBank,
    action: "Start Investing",
    image: investmentImg,
  },
  {
    title: "Financial Advisory",
    text: "Expert support to help individuals and SMEs make better financial decisions.",
    icon: TrendingUp,
    action: "Speak to Us",
    image: advisoryImg,
  },
];

const stats = [
  { value: "₦25M+", label: "Loans Processed" },
  { value: "98%", label: "Customer Trust" },
  { value: "24/7", label: "Support Access" },
  { value: "Fast", label: "Digital Approval" },
];

const marketProof = [
  "Salary Earners",
  "SME Owners",
  "Traders",
  "Investors",
  "Growing Businesses",
];

const highValueBenefits = [
  {
    icon: Banknote,
    title: "Flexible Finance",
    text: "Loan and lending support structured around customer needs and repayment confidence.",
  },
  {
    icon: ShieldCheck,
    title: "Trusted Verification",
    text: "A controlled process that helps protect customers, investors, and the business.",
  },
  {
    icon: Sparkles,
    title: "Premium Experience",
    text: "Modern digital journeys with simple steps, clear messaging, and human support.",
  },
];

const whyChoose = [
  {
    icon: LockKeyhole,
    title: "Bank-Level Security",
    text: "Secure, transparent, and trusted digital finance experience.",
  },
  {
    icon: Clock3,
    title: "Fast Processing",
    text: "Apply faster with a simple and customer-friendly process.",
  },
  {
    icon: BarChart3,
    title: "Growth Focused",
    text: "Built to help SMEs, traders, and individuals scale confidently.",
  },
  {
    icon: Headphones,
    title: "Human Support",
    text: "Get proper guidance before, during, and after your application.",
  },
];

const howItWorks = [
  {
    icon: Smartphone,
    title: "Start Online",
    text: "Begin your loan or investment journey from your phone or computer.",
  },
  {
    icon: FileCheck2,
    title: "Submit Details",
    text: "Provide required information through a simple guided process.",
  },
  {
    icon: UserCheck,
    title: "Get Reviewed",
    text: "Our team reviews your request and guides you through the next step.",
  },
  {
    icon: Banknote,
    title: "Receive Support",
    text: "Access funding, advisory, or investment support with confidence.",
  },
];

const customerTypes = [
  {
    icon: Store,
    title: "Traders",
    text: "Working capital support for daily business growth.",
  },
  {
    icon: BriefcaseBusiness,
    title: "SMEs",
    text: "Structured finance for expansion and operations.",
  },
  {
    icon: Users,
    title: "Individuals",
    text: "Personal finance support with human guidance.",
  },
];

const loanProducts = [
  {
    icon: Wallet,
    title: "Salary Loan",
    tag: "For salary earners",
    amount: "Up to ₦5M",
    tenor: "1 - 12 months",
    text: "Fast personal loan support with clear repayment guidance and customer-first review.",
  },
  {
    icon: Store,
    title: "Trader Loan",
    tag: "For daily businesses",
    amount: "₦100k - ₦3M",
    tenor: "Flexible tenor",
    text: "Working capital designed for market traders, agents, and small retail operators.",
  },
  {
    icon: BriefcaseBusiness,
    title: "SME Growth Loan",
    tag: "For businesses",
    amount: "Up to ₦20M",
    tenor: "3 - 18 months",
    text: "Structured finance to support stock purchase, expansion, operations, and cashflow.",
  },
  {
    icon: Building2,
    title: "Business Expansion",
    tag: "For growing brands",
    amount: "Custom offer",
    tenor: "Based on review",
    text: "Tailored lending support for established businesses with verified growth needs.",
  },
];

const trustBadges = [
  "Secure application flow",
  "Verified customer review",
  "Transparent repayment guidance",
  "Human support available",
  "Investor-conscious risk checks",
];

const serviceData: any = {
  "Business Loans": {
    title: "Peer-to-Peer Lending Model",
    text: "Investors provide capital, GMT deploys funds to carefully vetted borrowers, borrowers repay through structured systems, and investors receive fixed monthly returns.",
    image: businessLoanImg,
  },
  "Financial Planning": {
    title: "Structured Repayment Systems",
    text: "Our system reduces delays, improves loan monitoring, and ensures timely repayment through a controlled and transparent finance process.",
    image: financialPlanningImg,
  },
  "Cash Investment": {
    title: "Investor Returns",
    text: "We create opportunities for investors to earn fixed monthly returns while supporting salary earners and small business owners with access to finance.",
    image: cashInvestmentImg,
  },
  "Financial Consultancy": {
    title: "Inclusive Lending Solutions",
    text: "We use technology to simplify access to fast, reliable, and inclusive lending solutions across Nigeria and beyond.",
    image: consultancyImg,
  },
};

const aboutTabContent: Record<string, string> = {
  Story:
    "At GMT Technologies, we identified a critical gap in access to quick and reliable finance, especially among salary earners and small business owners. By leveraging technology and structured repayment systems, we have built a model that ensures fast loan disbursement, controlled risk exposure, and reliable repayment structures.",
  Mission:
    "To simplify access to finance by leveraging innovative technology to deliver fast, reliable, and inclusive lending solutions.",
  Vision:
    "To become a leading peer-to-peer lending technology company, driving financial inclusion and transforming how individuals and businesses access capital across Africa and beyond.",
};

const testimonials = [
  {
    text: "GMT Technologies Limited helped my Abuja business access funding quickly. The process was simple, transparent, and professional.",
    name: "Chinedu Okafor",
    role: "SME Owner, Abuja",
  },
  {
    text: "As a Lagos business owner, their financial planning support gave me the confidence to make better growth decisions.",
    name: "Amina Bello",
    role: "Business Owner, Lagos",
  },
  {
    text: "Their customer support is excellent. The loan process was clear from start to finish, and I felt properly guided.",
    name: "Tunde Adeyemi",
    role: "Trader, Ibadan",
  },
];

const trustArchitecture = [
  {
    icon: Fingerprint,
    title: "Identity Verification",
    text: "Structured customer checks before approval to support safer lending decisions.",
  },
  {
    icon: ShieldAlert,
    title: "Risk Review",
    text: "Applications are reviewed with controlled risk steps before funds are released.",
  },
  {
    icon: ReceiptText,
    title: "Transparent Records",
    text: "Clear repayment, loan, and investment records that improve customer confidence.",
  },
  {
    icon: LineChart,
    title: "Growth Insights",
    text: "Finance guidance designed to help customers make better business decisions.",
  },
];

const financeTimeline = [
  { title: "Apply", text: "Start your finance request online in a few guided steps." },
  { title: "Verify", text: "Submit customer details for review and confirmation." },
  { title: "Approve", text: "GMT reviews the request and communicates the next action." },
  { title: "Disburse", text: "Approved customers receive support with proper repayment guidance." },
];

const faqs = [
  {
    question: "How fast can I start?",
    answer: "You can begin online immediately. Final approval depends on review, verification, and eligibility checks.",
  },
  {
    question: "Is the process transparent?",
    answer: "Yes. The page clearly communicates requirements, repayment expectations, and support channels before customers proceed.",
  },
  {
    question: "Who can use GMT finance services?",
    answer: "Salary earners, traders, SMEs, investors, and growing businesses can explore suitable finance support.",
  },
];

export default function Home() {
  const [activeSlide, setActiveSlide] = useState(0);
  const [activeAboutTab, setActiveAboutTab] = useState("Story");
  const [activeService, setActiveService] = useState("Business Loans");

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % heroSlides.length);
    }, 4500);

    return () => clearInterval(timer);
  }, []);

  return (
    <main className="home-page">
      <section className="fintech-hero">
        <div className="hero-bg-orb hero-bg-orb-one" />
        <div className="hero-bg-orb hero-bg-orb-two" />
        <motion.div
          className="hero-copy"
          initial="hidden"
          animate="visible"
          transition={{ duration: 0.7 }}
          variants={fadeUp}
        >
          <div className="hero-eyebrow-row">
            <div className="hero-trust-badge">
              <ShieldCheck size={14} />
              <span>Trusted digital finance partner</span>
            </div>

            <div className="hero-rating-pill">
              <Star size={13} fill="currentColor" />
              <span>Customer-first finance</span>
            </div>
          </div>

          <h1>
            Smarter Loans, Secure Investments &{" "}
            <span>Financial Growth</span>
          </h1>

          <p>
            Access fast loans, secure investment opportunities, and expert
            financial support built for Nigerian individuals, SMEs, traders, and
            growing businesses.
          </p>

          <div className="hero-actions">
            <Link to="/applyloan" className="primary-btn">
              Apply for Loan <ArrowRight size={16} />
            </Link>

            <Link to="/about" className="secondary-btn">
              Learn More <ArrowRight size={16} />
            </Link>
          </div>

          <div className="premium-proof-row">
            <span>
              <CheckCircle2 size={16} /> No hidden charges
            </span>
            <span>
              <ShieldCheck size={16} /> Bank-grade security
            </span>
            <span>
              <Headphones size={16} /> Guided support
            </span>
          </div>

      <div className="hero-mini-stats premium-mini-cards">
  <motion.div
    whileHover={{ y: -6 }}
    transition={{ duration: 0.2 }}
    className="mini-premium-card"
  >
    <div className="mini-icon blue">
      <Zap size={18} />
    </div>

    <div>
      <strong>2 Mins</strong>
      <span>Average Approval</span>
    </div>

    <small>Lightning fast process</small>
  </motion.div>

  <motion.div
    whileHover={{ y: -6 }}
    transition={{ duration: 0.2 }}
    className="mini-premium-card"
  >
    <div className="mini-icon green">
      <ShieldCheck size={18} />
    </div>

    <div>
      <strong>Bank Grade</strong>
      <span>Security System</span>
    </div>

    <small>Encrypted & protected</small>
  </motion.div>

  <motion.div
    whileHover={{ y: -6 }}
    transition={{ duration: 0.2 }}
    className="mini-premium-card"
  >
    <div className="mini-icon purple">
      <Users size={18} />
    </div>

    <div>
      <strong>12K+</strong>
      <span>Happy Customers</span>
    </div>

    <small>Trusted across Nigeria</small>
  </motion.div>
</div>
        </motion.div>

        <motion.div
          className="hero-visual"
          initial={{ opacity: 0, scale: 0.94 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="hero-visual-shine" />
          <div className="hero-status-pill">
            <span className="status-dot" />
            Live digital finance support
          </div>

          <AnimatePresence mode="wait">
            <motion.img
              key={activeSlide}
              src={heroSlides[activeSlide]}
              alt="GMT Technologies financial services"
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.98 }}
              transition={{ duration: 0.9, ease: "easeOut" }}
            />
          </AnimatePresence>

          <div className="floating-card card-one">
            <strong>₦25M+</strong>
            <span>Loans Processed</span>
          </div>

          <div className="floating-card card-two">
            <strong>98%</strong>
            <span>Customer Trust</span>
          </div>




          <div className="hero-dots">
            {heroSlides.map((_, index) => (
              <button
                key={index}
                className={activeSlide === index ? "active" : ""}
                onClick={() => setActiveSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>

          <div className="hero-glass-panel">
            <span>Smart Finance</span>
            <strong>Loan • Lending • Advisory</strong>
          </div>
        </motion.div>
      </section>

     


     

      <section className="market-proof-strip">
        <div className="market-proof-track">
          {marketProof.map((item) => (
            <span key={item}>
              <CheckCircle2 size={16} />
              {item}
            </span>
          ))}
        </div>
      </section>

      <section className="fintech-trust-badges">
        {trustBadges.map((item) => (
          <div className="fintech-trust-badge" key={item}>
            <BadgeCheck size={18} />
            <span>{item}</span>
          </div>
        ))}
      </section>

      <motion.section
        className="premium-benefit-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div className="premium-benefit-head">
          <span>Why Customers Notice Us</span>
          <h2>Built to feel simple, secure, and worth trusting from the first click</h2>
        </div>

        <div className="premium-benefit-grid">
          {highValueBenefits.map((item) => {
            const Icon = item.icon;

            return (
              <div className="premium-benefit-card" key={item.title}>
                <div className="premium-benefit-icon">
                  <Icon size={24} />
                </div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
                <span className="premium-benefit-link">
                  Explore <ChevronRight size={15} />
                </span>
              </div>
            );
          })}
        </div>
      </motion.section>

      <motion.section
        className="stats-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        {stats.map((item) => (
          <div className="stat-card" key={item.label}>
            <strong>{item.value}</strong>
            <span>{item.label}</span>
          </div>
        ))}
      </motion.section>

      <motion.section
        className="section-block"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div className="section-inner">
          <div className="section-heading">
            <span>Our Services</span>
            <h2>Beautiful digital finance services made for customer confidence</h2>
          </div>

          <div className="service-grid">
            {services.map((service) => {
              const Icon = service.icon;

              return (
                <div className="service-card" key={service.title}>
                  <div className="service-icon">
                    <Icon size={26} />
                  </div>

                  <h3>{service.title}</h3>
                  <p>{service.text}</p>

                  <Link to="/applyloan" className="service-link">
                    {service.action} →
                  </Link>

                  <img
                    src={service.image}
                    alt={service.title}
                    className="service-card-img"
                  />
                </div>
              );
            })}
          </div>
        </div>
      </motion.section>

      <motion.section
        className="fintech-experience"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div className="experience-card">
          <div className="experience-icon">
            <Smartphone size={26} />
          </div>
          <h3>Digital-first experience</h3>
          <p>A smooth finance journey designed for speed, clarity, and trust.</p>
        </div>

        <div className="experience-card active">
          <div className="experience-icon">
            <Building2 size={26} />
          </div>
          <h3>Built for SMEs</h3>
          <p>Funding and advisory support for traders, businesses, and growing companies.</p>
        </div>

        <div className="experience-card">
          <div className="experience-icon">
            <BadgeCheck size={26} />
          </div>
          <h3>Transparent process</h3>
          <p>Clear requirements, no confusing process, and support at every step.</p>
        </div>
      </motion.section>

      <motion.section
        className="how-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div className="section-heading">
          <span>How It Works</span>
          <h2>Simple steps from application to financial support</h2>
        </div>

        <div className="how-grid">
          {howItWorks.map((item, index) => {
            const Icon = item.icon;

            return (
              <div className="how-card" key={item.title}>
                <div className="how-count">0{index + 1}</div>
                <div className="how-icon">
                  <Icon size={24} />
                </div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            );
          })}
        </div>
      </motion.section>

      <motion.section
        className="loan-products-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div className="section-heading">
          <span>Loan Products</span>
          <h2>Clear finance options that make customers ready to apply</h2>
        </div>

        <div className="loan-products-grid">
          {loanProducts.map((item) => {
            const Icon = item.icon;

            return (
              <motion.div
                className="loan-product-card"
                key={item.title}
                whileHover={{ y: -8 }}
                transition={{ duration: 0.22 }}
              >
                <div className="loan-product-top">
                  <div className="loan-product-icon">
                    <Icon size={24} />
                  </div>
                  <span>{item.tag}</span>
                </div>

                <h3>{item.title}</h3>
                <p>{item.text}</p>

                <div className="loan-product-meta">
                  <div>
                    <small>Amount</small>
                    <strong>{item.amount}</strong>
                  </div>
                  <div>
                    <small>Tenor</small>
                    <strong>{item.tenor}</strong>
                  </div>
                </div>

                <Link to="/applyloan" className="loan-product-link">
                  Apply for this loan <ArrowRight size={15} />
                </Link>
              </motion.div>
            );
          })}
        </div>
      </motion.section>

      <motion.section
        className="calculator-showcase"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div className="calculator-copy">
          <span>Smart Finance Preview</span>
          <h2>Plan your loan before you apply</h2>
          <p>
            Give customers a modern preview experience with loan amount,
            estimated repayment, and application confidence before they begin.
          </p>

          <Link to="/applyloan" className="primary-btn">
            Start Loan Application <ArrowRight size={16} />
          </Link>
        </div>

        <div className="loan-preview-card">
          <div className="loan-preview-header">
            <div>
              <Calculator size={24} />
              <span>Loan Estimate</span>
            </div>
            <strong>Preview</strong>
          </div>

          <div className="loan-preview-row">
            <span>Loan Amount</span>
            <strong>₦2,500,000</strong>
          </div>

          <div className="loan-preview-row">
            <span>Estimated Tenor</span>
            <strong>6 Months</strong>
          </div>

          <div className="loan-preview-row">
            <span>Monthly Repayment</span>
            <strong>₦450,000</strong>
          </div>

          <div className="loan-preview-progress">
            <span />
          </div>

          <p>Final repayment depends on approved offer and verification.</p>
        </div>
      </motion.section>

      <motion.section
        className="why-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div className="section-heading">
          <span>Why Choose GMT</span>
          <h2>Built for customers who want speed, trust and growth</h2>
        </div>

        <div className="why-grid">
          {whyChoose.map((item) => {
            const Icon = item.icon;

            return (
              <div className="why-card" key={item.title}>
                <div className="why-icon">
                  <Icon size={24} />
                </div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            );
          })}
        </div>
      </motion.section>

      <motion.section
        className="customer-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div className="customer-copy">
          <span>Who We Serve</span>
          <h2>Financial support for real Nigerian customers</h2>
        </div>

        <div className="customer-grid">
          {customerTypes.map((item) => {
            const Icon = item.icon;

            return (
              <div className="customer-card" key={item.title}>
                <Icon size={26} />
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            );
          })}
        </div>
      </motion.section>

      <motion.section
        className="growth-showcase"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div className="growth-copy">
          <span>Built for Nigerians</span>
          <h2>Access finance with confidence, speed and transparency</h2>

          <p>
            Whether you are a salary earner, trader, SME owner, or growing
            business, GMT Technologies Limited gives you a trusted digital path
            to loans, investment support, and financial advisory.
          </p>

          <div className="growth-points">
            <div>
              <CheckCircle2 size={18} />
              Fast loan application process
            </div>
            <div>
              <CheckCircle2 size={18} />
              Secure investment support
            </div>
            <div>
              <CheckCircle2 size={18} />
              Human support when you need help
            </div>
          </div>

          <Link to="/applyloan" className="primary-btn">
            Start Your Application <ArrowRight size={16} />
          </Link>
        </div>

        <div className="growth-image">
          <img src={growthImg} alt="Nigerian customer financial growth" />

          <div className="growth-floating-card">
            <strong>Trusted</strong>
            <span>By Nigerian businesses</span>
          </div>
        </div>
      </motion.section>

      <motion.section
        className="about-modern"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div className="about-main">
          <div className="about-image">
            <img src={aboutImg} alt="About GMT Technologies" />
          </div>

          <div className="about-copy">
            <span className="section-label">About Us</span>

            <h2>We help customers grow with smart financial solutions</h2>

            <p>
           GMT Technologies Limited simplifies access to finance through technology-driven lending solutions. Our model connects investors, carefully vetted borrowers, and structured repayment systems to deliver fast, reliable, and inclusive financial support.
            </p>

            <div className="about-tabs">
              {["Story", "Mission", "Vision"].map((tab) => (
                <motion.button
                  key={tab}
                  type="button"
                  className={activeAboutTab === tab ? "active" : ""}
                  onClick={() => setActiveAboutTab(tab)}
                  whileTap={{ scale: 0.95 }}
                >
                  {tab}

                  {activeAboutTab === tab && (
                    <motion.div
                      layoutId="tabIndicator"
                      className="tab-indicator"
                      transition={{
                        type: "spring",
                        stiffness: 400,
                        damping: 30,
                      }}
                    />
                  )}
                </motion.button>
              ))}
            </div>

            <AnimatePresence mode="wait">
              <motion.div
                key={activeAboutTab}
                className="about-tab-content"
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -15 }}
                transition={{ duration: 0.35, ease: "easeOut" }}
              >
                {aboutTabContent[activeAboutTab]}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>

        <div className="about-features">
          <div>
            <span>₦</span>
            <h4>No Hidden Cost</h4>
            <p>Clear and upfront pricing with no surprise charges.</p>
          </div>

          <div>
            <span>
              <Users size={22} />
            </span>
            <h4>Dedicated Team</h4>
            <p>Experienced support from application to completion.</p>
          </div>

          <div>
            <span>
              <PhoneCall size={22} />
            </span>
            <h4>Always Available</h4>
            <p>We are here whenever you need financial support.</p>
          </div>
        </div>
      </motion.section>

      <motion.section
        className="business-services"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div className="business-services-inner">
          <div className="section-heading">
            <span>Business Finance</span>
            <h2>Financial services designed for serious business growth</h2>
          </div>

          <div className="business-services-grid">
            <div className="business-service-menu">
              {Object.keys(serviceData).map((item) => (
                <button
                  key={item}
                  className={activeService === item ? "active" : ""}
                  onClick={() => setActiveService(item)}
                >
                  <Landmark size={18} />
                  {item}
                </button>
              ))}
            </div>

            <div className="business-service-image">
              <AnimatePresence mode="wait">
                <motion.img
                  key={activeService}
                  src={serviceData[activeService].image}
                  alt={activeService}
                  initial={{ opacity: 0, scale: 0.96 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 1.03 }}
                  transition={{ duration: 0.4, ease: "easeOut" }}
                />
              </AnimatePresence>
            </div>

            <div className="business-service-content">
              <AnimatePresence mode="wait">
                <motion.div
                  key={activeService}
                  initial={{ opacity: 0, y: 18 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -18 }}
                  transition={{ duration: 0.35, ease: "easeOut" }}
                >
                  <h3>{serviceData[activeService].title}</h3>
                  <p>{serviceData[activeService].text}</p>
                </motion.div>
              </AnimatePresence>

              <ul>
                <li>
                  <CheckCircle2 size={18} /> Secured Loans
                </li>
                <li>
                  <CheckCircle2 size={18} /> Credit Facilities
                </li>
                <li>
                  <CheckCircle2 size={18} /> Cash Advance Support
                </li>
              </ul>

              <Link to="/applyloan" className="business-service-btn">
                Get Started <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </motion.section>

      <motion.section
        className="trust-architecture-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div className="trust-architecture-copy">
          <span>Security & Confidence</span>
          <h2>First-class fintech trust layer for serious customers</h2>
          <p>
            Add a visible security and process layer so customers immediately
            feel they are dealing with a structured, reliable finance company.
          </p>
        </div>

        <div className="trust-architecture-layout">
          <div className="trust-architecture-grid">
            {trustArchitecture.map((item) => {
              const Icon = item.icon;

              return (
                <div className="trust-architecture-card" key={item.title}>
                  <div className="trust-architecture-icon">
                    <Icon size={24} />
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              );
            })}
          </div>

          <div className="security-visual-card">
            <div className="security-phone-mockup">
              <div className="security-phone-header">
                <span />
                <strong>GMT Secure</strong>
              </div>

              <div className="security-check-ring">
                <Fingerprint size={42} />
              </div>

              <h3>Customer Verified</h3>
              <p>Identity, risk, repayment and support checks are clearly structured.</p>

              <div className="security-status-list">
                <span><CheckCircle2 size={15} /> BVN / ID Review</span>
                <span><CheckCircle2 size={15} /> Loan Risk Check</span>
                <span><CheckCircle2 size={15} /> Repayment Guidance</span>
              </div>
            </div>
          </div>
        </div>
      </motion.section>

      <motion.section
        className="finance-timeline-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div className="section-heading">
          <span>Live Process Feel</span>
          <h2>A modern application journey customers can understand instantly</h2>
        </div>

        <div className="finance-timeline">
          {financeTimeline.map((item, index) => (
            <div className="finance-timeline-card" key={item.title}>
              <div className="timeline-number">0{index + 1}</div>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </motion.section>

      <motion.section
        className="faq-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div className="faq-copy">
          <span>Customer Questions</span>
          <h2>Answer doubts before customers leave the page</h2>
          <p>
            A strong fintech homepage should reduce fear, explain the process,
            and guide customers clearly to the next step.
          </p>
        </div>

        <div className="faq-list">
          {faqs.map((item) => (
            <div className="faq-card" key={item.question}>
              <div className="faq-icon">
                <MessageCircleQuestion size={22} />
              </div>
              <div>
                <h3>{item.question}</h3>
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </motion.section>

      <motion.section
        className="investment-cta"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div>
          <span>Start Growing Today</span>
          <h2>Ready to access funding or grow your investment?</h2>
          <p>
            Take the next step with a reliable financial technology partner
            focused on trust, speed, and customer growth.
          </p>
        </div>

        <Link to="/applyloan" className="primary-btn">
          Apply Now <ArrowRight size={16} />
        </Link>
      </motion.section>

      <motion.section
        className="testimonial-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7 }}
        variants={fadeUp}
      >
        <div className="section-heading">
          <span>Testimonials</span>
          <h2>What Nigerian customers say about GMT Technologies</h2>
        </div>

        <div className="testimonial-grid">
          {testimonials.map((item) => (
            <div className="testimonial-card" key={item.name}>
              <div className="quote">”</div>
              <p>{item.text}</p>
              <h4>{item.name}</h4>
              <span>{item.role}</span>
            </div>
          ))}
        </div>
      </motion.section>
      <div className="mobile-sticky-cta">
        <Link to="/applyloan">
          Apply for Loan <ArrowRight size={16} />
        </Link>
      </div>
    </main>
  );
}